import { render, staticRenderFns } from "./market-extras.vue?vue&type=template&id=f04b4748&scoped=true"
import script from "./market-extras.vue?vue&type=script&lang=js"
export * from "./market-extras.vue?vue&type=script&lang=js"
import style0 from "./market-extras.vue?vue&type=style&index=0&id=f04b4748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04b4748",
  null
  
)

export default component.exports